<template>
  <div>
    <van-panel
      v-for="caseAttachDirectory in directories"
      :key="caseAttachDirectory.id"
      class="attachment-panel"
      :title="caseAttachDirectory.orderNo+' . '+caseAttachDirectory.name"
      :desc="caseAttachDirectory.description"
      :status="caseAttachDirectory.isRequired?'[ 必须 ]':null"
    >
      <van-grid
        :column-num="4"
        :gutter="15"
        :border="false"
        square
      >
        <van-grid-item
          v-for="caseAttach in caseAttachDirectory.caseAttaches"
          :key="caseAttach.id"
        >
          <van-image
            :src="getImageUrl(caseAttach.id)"
            lazy-load
            fit="cover"
            width="100%"
            height="100%"
            @click="handlePreviewImage(caseAttach.id)"
          >
            <template v-slot:loading>
              <van-loading type="spinner" size="20" />
            </template>
          </van-image>
          <van-button
            v-if="isEditable"
            class="button-delete"
            type="danger"
            icon="cross"
            @click="handleDeleteImage(caseAttach.id)"
          />
        </van-grid-item>
        <van-grid-item v-if="isEditable&&isJsSdkReady">
          <van-button
            class="button-add"
            type="default"
            icon="plus"
            block
            square
            @click="handleChooseImage(caseAttachDirectory.id)"
          />
        </van-grid-item>
        <van-grid-item
          v-if="!isEditable&&caseAttachDirectory.caseAttaches.length===0"
          class="empty"
          text="空"
        />
      </van-grid>
    </van-panel>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import { uploadCaseAttach, deleteCaseAttach } from '@/api/application'
import { getImageDataUri } from '@/api/weChat'
import { dataUriToBlob } from '@/utils'
import { Toast } from 'vant'
import Vue from 'vue'
import Lazyload from 'vue-lazyload'

Vue.use(Lazyload, {
  preLoad: 1.1,
  attempt: 1,
  lazyComponent: true
})

export default {
  props: {
    caseAttachDirectories: {
      type: Array,
      default: () => []
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isJsSdkReady: false,
      directories: this.caseAttachDirectories,
      queuedFiles: [],
      isUploading: false
    }
  },
  computed: {
    jsApiList: function() {
      return this.isEditable ? ['previewImage', 'chooseImage', 'uploadImage'] : ['previewImage']
    },
    caseAttaches: function() {
      let caseAttaches = []
      this.directories.forEach(d => {
        caseAttaches = caseAttaches.concat(d.caseAttaches)
      })
      return caseAttaches
    },
    imageUrls: function() {
      return this.caseAttaches.map(a => {
        return this.getImageUrl(a.id)
      })
    }
  },
  watch: {
    caseAttachDirectories: function(newCaseAttachDirectories) {
      this.directories = newCaseAttachDirectories
    },
    queuedFiles: function() {
      if (this.queuedFiles.length > 0 && !this.isUploading) {
        // 设置上传标记
        this.isUploading = true
        // 显示上传进度
        Toast.loading({
          message: '上传中...',
          duration: 0
        })
        // 上传文件
        this.uoloadImage(this.queuedFiles[0]).then(caseAttach => {
          this.directories.find(d => d.id === caseAttach.caseAttachDirectoryId)
            .caseAttaches.push(caseAttach)
          // 移出上传队列
          this.queuedFiles.shift()
          // 设置上传标记
          this.isUploading = false
          // 上传成功，清除上传进度
          Toast.clear()
        }).catch(error => {
          // 上传失败，显示错误信息
          Toast.fail(error.message)
        })
      }
    },
    directories: {
      handler() {
        const isValid = !this.directories.some(d => d.isRequired && d.caseAttaches.length === 0)
        this.$emit('validate', isValid)
        this.$emit('change', this.directories)
      },
      deep: true
    }
  },
  created() {
    // 显示加载进度
    Toast.loading({
      message: '加载中...',
      duration: 0
    })
    // 配置微信js开发包
    this.$store.dispatch('weChat/setWeChatConfig', {
      // debug: true,
      jsApiList: this.jsApiList
    }).then(() => {
      // 微信js开发包准备完成
      this.isJsSdkReady = true
      // 加载成功，清除加载进度
      Toast.clear()
    }).catch(error => {
      // 加载失败，显示错误信息
      Toast.fail(error.message)
    })
  },
  methods: {
    // 获取图片完整url
    getImageUrl(id) {
      console.info(id)
      console.info(`${process.env.VUE_APP_RECSS_BASE_API}/caseAttach/${id}/file`)
      return `${process.env.VUE_APP_RECSS_BASE_API}/caseAttach/${id}/file`
    },
    // 处理预览图片事件
    handlePreviewImage(id) {
      const _this = this
      // 微信预览图片
      wx.previewImage({
        current: _this.getImageUrl(id),
        urls: _this.imageUrls
      })
    },
    // 处理选择图片事件
    handleChooseImage(caseAttachDirectoryId) {
      const _this = this
      // 微信选择图片
      wx.chooseImage({
        count: 9,
        sizeType: ['original', 'compressed'], // original：原图，compressed：压缩
        sourceType: ['camera', 'album'], // album：相册，camera：相机
        success: function(response) {
          const newFiles = response.localIds.map(localId => {
            return { localId, caseAttachDirectoryId }
          })
          _this.queuedFiles = _this.queuedFiles.concat(newFiles)
        }
      })
    },
    // 处理删除图片
    handleDeleteImage(id) {
      // 显示删除进度
      Toast.loading({
        message: '删除中...',
        duration: 0
      })
      // 删除案卷附件
      deleteCaseAttach(id).then(() => {
        // 将案卷附件从对应目录中移除
        let i = -1
        const caseAttachDirectory = this.directories.find(d => {
          return (i = d.caseAttaches.findIndex(a => a.id === id)) >= 0
        })
        if (caseAttachDirectory) {
          caseAttachDirectory.caseAttaches.splice(i, 1)
        }
        // 删除成功，清除加载进度
        Toast.clear()
      }).catch(error => {
        // 删除失败，显示错误信息
        Toast.fail(error.message)
      })
    },
    // 上传图片
    uoloadImage({ localId, caseAttachDirectoryId }) {
      return new Promise((resolve, reject) => {
        // 微信上传图片
        wx.uploadImage({
          localId,
          isShowProgressTips: 1, // 显示进度提示
          success: function({ serverId }) {
            // 获取表示微信图片的DataUri
            getImageDataUri(serverId).then(({ data }) => {
              const formData = new FormData()
              formData.append('file', dataUriToBlob(data), `${serverId}.jpg`)
              formData.append('caseAttachDirectoryId', caseAttachDirectoryId)
              // 上传附件至服务端
              uploadCaseAttach(formData).then(({ data }) => {
                resolve(data)
              }).catch(error => {
                reject(error)
              })
            }).catch(error => {
              reject(error)
            })
          }
        })
      })
    }
  }
}
</script>

<style lang="scss">
.van-grid-item__content {
  padding: 0;
}
.empty{
  .van-grid-item__content{
    border:1px dashed #ebedf0;
  }
}
.attachment-panel .van-cell:not(:last-child)::after{
  border-bottom-width:0px;
}
</style>

<style scoped lang="scss">
.van-panel{
  margin-bottom: 15px;
  .van-panel__header{
    .van-cell__title{
    color: rgba(69, 90, 100, 0.6);
    }
  }
  .van-panel__content{
    .van-grid-item__content{
    .button-delete{
      padding: 0px;
      position: absolute;
      right: -10px;
      top: -10px;
      width: 20px;
      height: 20px;
      line-height: 20px;
      border-radius: 10px;
    }
  }
  .button-add{
    height: 100%;
    border-style: dashed;
    color:#ebedf0;
    font-size: 20px;
  }
  }
}
</style>
